import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// ----------------------------------------------------------------------

export default function useChunkLoad() {
    const location = useLocation();

    useEffect(() => {
        const originalConsoleError = console.error;

        const errorHandler = (e) => {
            if (e?.message?.includes("Loading chunk")) {
                console.warn("Chunk load failed, reloading page...");
                window.location.reload();
            }
        };

        window.addEventListener("error", errorHandler);
        window.addEventListener("unhandledrejection", (e) => {
            if (e?.reason?.message?.includes("Loading chunk")) {
                window.location.reload();
            }
        });

        return () => {
            window.removeEventListener("error", errorHandler);
            window.console.error = originalConsoleError;
        };
    }, [location]);
}
